import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { Image } from 'components/core/Image';

import './iconText.scss';

export function IconText({
	className,
	textClassName,
	src,
	icon,
	children,
	size,
	color,
	type,
	weight,
	lazyLoad,
	alt,
	imageClassName,
	iconFill,
}) {
	return (
		<div className={classnames('icon-text', className, type, color)}>
			{!!src && (
				<Image
					src={src}
					alt={alt}
					lazyLoad={lazyLoad}
					className={imageClassName}
				/>
			)}
			{!!icon && React.createElement(icon, { fill: iconFill })}
			<div className={classnames(textClassName, 'text')}>
				<Text
					weight={weight}
					size={size}
					color={color}
					last
				>
					{children}
				</Text>
			</div>
		</div>
	);
}

IconText.propTypes = {
	className: PropTypes.string,
	textClassName: PropTypes.string,
	children: PropTypes.node.isRequired,
	size: PropTypes.string,
	color: PropTypes.string,
	src: PropTypes.string,
	icon: PropTypes.func,
	type: PropTypes.oneOf([
		'standard',
		'info',
		'alert',
		'success',
		'inline-text',
	]),
	weight: PropTypes.string,
	lazyLoad: PropTypes.bool,
	alt: PropTypes.string,
	imageClassName: PropTypes.string,
	iconFill: PropTypes.string,
};

IconText.defaultProps = {
	size: 'medium',
	type: 'standard',
	weight: 'bold',
};

export default IconText;
